import React, { useEffect, useState } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const domainOf = (e) => (e && e.includes('@') ? e.split('@').pop().trim().toLowerCase() : '');

export const DraftForm = ({ draft, setupRequired, onSave }) => {
  const init = { from_name: draft.from_name, sender_email: draft.sender_email, reply_to: draft.reply_to };
  const [f, setF] = useState(init);
  useEffect(() => setF({ from_name: draft.from_name, sender_email: draft.sender_email, reply_to: draft.reply_to }), [draft.from_name, draft.sender_email, draft.reply_to]);
  const field = (k, label, props = {}) => (
    <div><Label className="text-xs">{label}</Label><Input value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1" data-testid={`email-${k}`} {...props} /></div>
  );
  return (
    <div className="space-y-3" data-testid="email-settings-form">
      <div><Label className="text-xs">Email Provider</Label><Input value="Resend" disabled className="mt-1" data-testid="email-provider" /></div>
      {field('from_name', 'From Name', { placeholder: 'Your business name' })}
      {field('sender_email', 'Sender Email', { type: 'email', placeholder: 'notifications@yourdomain.com' })}
      <div><Label className="text-xs">Sending Domain</Label><Input value={domainOf(f.sender_email)} disabled className="mt-1" data-testid="email-sending-domain" />
        <p className="text-xs text-neutral-500 mt-1">Taken from the Sender Email automatically.</p></div>
      {field('reply_to', 'Reply-To Email', { type: 'email', placeholder: 'you@yourcompany.com' })}
      <p className="text-xs text-neutral-500">{setupRequired ? 'Saving stores the draft. No customer emails go out until this sender passes every check and is activated.' : 'Saving changes the draft only. The live sender keeps working until you activate this one.'}</p>
      <Button onClick={() => onSave(f)} data-testid="email-save">Save Draft</Button>
    </div>
  );
};
